import Route from '@ember/routing/route';
import { set } from '@ember/object';
import { inject as iService } from '@ember/service';

export default class CheckinRoute extends Route {
  @iService session;

  async beforeModel() {
    if (this.session.me?.id) {
      this.session.logout();
      await this.session.loadOpenTask.perform(true);
    }
  }

  model() {}

  setupController(controller /*, model*/) {
    super.setupController(...arguments);
    controller.loadDataTask.perform();
  }

  resetController(controller) {
    controller.loadDataTask.cancelAll();
    set(controller, 'me', null);
    set(controller, 'checkAPIMail', null);
    set(controller, 'saveAPIMe', null);
  }
}
